/** Convert first letter of input to uppercase */
export const capitalize = (input: string): string => input.charAt(0).toUpperCase() + input.slice(1)
